import appStyles from "../../../App.module.css";
const PPLoadingIndicator = () => {
  return (
    <div className={appStyles.bfSpinnerOverlay}>
      <div className={appStyles.bfSpinner}></div>
    </div>
  );
};

export default PPLoadingIndicator;
